import { render, staticRenderFns } from "./AddToListDialog.vue?vue&type=template&id=22bf2724&scoped=true"
import script from "./AddToListDialog.vue?vue&type=script&lang=js"
export * from "./AddToListDialog.vue?vue&type=script&lang=js"
import style0 from "./AddToListDialog.vue?vue&type=style&index=0&id=22bf2724&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf2724",
  null
  
)

export default component.exports